export const pagesEs = {
  calendarPage: {
    title: "📅 Calendario de Campo",
    subtitle: "Gestiona tus recordatorios agrícolas y tareas programadas",
    fieldCalendar: "Calendario de Campo y Recordatorios",
    newReminder: "Nuevo Recordatorio",
    createFieldReminder: "Crear Recordatorio de Campo",
    reminderType: "Tipo",
    reminderIrrigation: "Riego",
    reminderFertilization: "Fertilización",
    reminderTreatment: "Tratamiento",
    reminderHarvest: "Cosecha",
    reminderInspection: "Inspección",
    reminderCustom: "Personalizado",
    reminderTitle: "Título",
    reminderTitlePlaceholder: "ej., Aplicar riego",
    reminderDescription: "Descripción",
    reminderDescPlaceholder: "Detalles adicionales...",
    reminderPriority: "Prioridad",
    priorityLow: "Baja",
    priorityMedium: "Media",
    priorityHigh: "Alta",
    priorityUrgent: "Urgente",
    scheduledDate: "Fecha Programada",
    createReminder: "Crear Recordatorio",
    overdue: "Vencidas",
    upcoming: "Próximas",
    completed: "Completadas",
    noRemindersYet: "Sin recordatorios aún",
    createFirstReminder: "Crea tu primer recordatorio para empezar",
    autoGenerated: "Auto-generado",
    reminderCreated: "Recordatorio creado exitosamente",
    reminderCreateFailed: "Error al crear recordatorio",
    reminderCompleted: "Recordatorio completado",
    reminderIncomplete: "Recordatorio marcado como incompleto",
    reminderUpdateFailed: "Error al actualizar recordatorio",
    reminderDeleted: "Recordatorio eliminado",
    reminderDeleteFailed: "Error al eliminar recordatorio",
    loadFailed: "Error al cargar recordatorios"
  },
  fireDetectionPage: {
    title: "Monitoreo de Riesgo de Incendio (Derivado de Satélite)",
    subtitle: "Alertas de riesgo de incendio derivadas de satélite — Monitoreo de focos térmicos NASA FIRMS + análisis de área quemada Sentinel-2. No es un servicio de emergencias.",
    nasaFirms: "NASA FIRMS (VIIRS)",
    realTimeDetection: "Señales satelitales de focos térmicos casi en tiempo real (VIIRS, latencia ~3–6h)",
    dataLatency: "Latencia de datos de 3-4 horas",
    spatialRes: "Resolución espacial de 375m",
    globalCoverage: "Cobertura global (SNPP + NOAA-20)",
    sentinel2Swir: "Análisis SWIR Sentinel-2",
    postFireMapping: "Mapeo de área quemada post-incendio",
    resolution20m: "Resolución de 20m (bandas SWIR)",
    dnbrSeverity: "Clasificación de severidad dNBR",
    recoveryEstimation: "Estimación de tiempo de recuperación",
    selectParcel: "Seleccionar Parcela",
    selectParcelDesc: "Elige una parcela para verificar señales satelitales de riesgo de incendio en un radio de 50km",
    noParcels: "No se encontraron parcelas. Añade una parcela primero para usar el monitoreo de riesgo de incendio.",
    // Panel translations
    activeFireAlerts: "Alertas de Focos Térmicos Satelitales",
    riskLabel: "Riesgo {{level}}",
    firesCountAway: "{{count}} señal(es) de foco térmico • {{distance}}km de distancia",
    dismiss: "Descartar",
    smsSent: "SMS Enviado",
    panelTitle: "Monitoreo de Riesgo de Incendio (Derivado de Satélite)",
    panelSubtitle: "Verificación automática de focos térmicos satelitales cada 4 horas usando NASA FIRMS + análisis de área quemada Sentinel-2",
    alertSettings: "Configuración de Alertas",
    hideSettings: "Ocultar Configuración",
    automaticAlerts: "Alertas Automáticas",
    automaticAlertsDesc: "Verificar cada 4 horas automáticamente",
    smsNotifications: "Notificaciones SMS",
    smsNotificationsDesc: "Recibir SMS cuando se detecte un foco térmico satelital cerca de tu parcela",
    phoneLabel: "Número de Teléfono (con código de país)",
    minRiskLevel: "Nivel de Riesgo Mínimo",
    criticalOnly: "Solo Crítico",
    highCritical: "Alto + Crítico",
    moderatePlus: "Moderado+",
    allLevels: "Todos los niveles",
    detectionRadius: "Radio de Detección (km)",
    saveSettings: "Guardar Configuración",
    saving: "Guardando...",
    settingsSaved: "Configuración Guardada",
    settingsSavedDesc: "Tu configuración de alertas de riesgo de incendio ha sido actualizada",
    settingsSaveError: "No se pudo guardar la configuración",
    alertDismissed: "Alerta descartada",
    autoMonitoring: "Monitoreo Automático:",
    autoMonitoringEnabled: "El sistema verifica todas las parcelas cada 4 horas. Alertas habilitadas para nivel {{level}}+.",
    autoMonitoringDisabled: "El sistema verifica todas las parcelas cada 4 horas. Las alertas automáticas están desactivadas.",
    smsActive: "Notificaciones SMS activas.",
    parcelLabel: "Parcela: {{name}}",
    radiusLabel: "Radio: {{radius}} km",
    scanningFires: "Buscando señales satelitales de focos térmicos...",
    manualCheckNow: "Verificar Ahora",
    currentRiskLevel: "Nivel de Riesgo Actual",
    activeFiresDetected: "Focos Térmicos Satelitales Detectados ({{count}}) — Requiere Validación",
    kmAway: "{{distance}} km de distancia",
    confidence: "Confianza: {{value}}",
    fireLocationMap: "Mapa de Focos Térmicos Satelitales",
    fireLocationMapDesc: "Tu parcela (verde) y señales satelitales de focos térmicos (rojo/naranja) en un radio de {{radius}} km",
    burnedAreaAnalysis: "Análisis de Área Quemada (Sentinel-2)",
    severity: "Severidad",
    affectedArea: "Área Afectada",
    dnbrIndex: "Índice dNBR",
    estRecovery: "Recuperación Est.",
    days: "{{count}} días",
    recommendations: "Recomendaciones",
    dataSources: "Fuentes de datos: {{sources}}",
    activeFiresDetectedToast: "⚠️ Focos Térmicos Satelitales Detectados — Requiere Validación",
    activeFiresDetectedDesc: "{{count}} señal(es) satelital(es) de foco térmico en un radio de {{radius}}km de tu parcela. No sustituye las alertas oficiales.",
    noActiveFiresToast: "Sin Señales de Focos Térmicos",
    noActiveFiresDesc: "No se detectaron señales satelitales de focos térmicos cerca de tu parcela",
    detectionError: "Error de Monitoreo",
    detectionErrorDesc: "No se pudo completar la verificación de focos térmicos satelitales",
    experimentalPropagation: "Simulación experimental de propagación de fuego",
    experimentalPropagationDesc: "No calibrada — solo para uso de investigación",
    openPropagation: "Abrir simulación →",
    disclaimer: "Las alertas de riesgo de incendio derivadas de satélite no son un servicio de emergencias y no sustituyen las alertas oficiales ni las indicaciones de Protección Civil / 112.",
    hotspotDisclaimerShort: "Posible señal satelital relacionada con incendio · Requiere validación · No es un servicio de emergencias"
  },
  seasonsPage: {
    title: "Temporadas de Cultivo",
    subtitle: "Rastrea y compara tus temporadas de cultivo en todas las parcelas",
    filterByParcel: "Filtrar por parcela",
    allParcels: "Todas las Parcelas",
    newSeason: "Nueva Temporada",
    activeSeasons: "Temporadas Activas",
    completedSeasons: "Temporadas Completadas",
    avgYield: "Rendimiento Promedio",
    waterEfficiency: "Eficiencia Hídrica",
    active: "Activas",
    historical: "Historial",
    all: "Todas",
    noActiveSeasons: "Sin Temporadas Activas",
    noActiveSeasonsDesc: "Comienza a rastrear tu primera temporada de cultivo para desbloquear comparaciones de rendimiento y métricas de eficiencia hídrica.",
    createSeason: "Crear Temporada",
    noCompletedSeasons: "Sin Temporadas Completadas Aún",
    noCompletedSeasonsDesc: "Los datos históricos aparecerán aquí una vez que completes tu primera temporada.",
    noSeasonsFound: "No Se Encontraron Temporadas",
    noSeasonsFoundDesc: "Crea tu primera temporada de cultivo para empezar a rastrear.",
    viewDetails: "Ver Detalles",
    harvested: "Cosechada",
    cancelled: "Cancelada",
    planning: "Planificación"
  },
  newSeasonDialog: {
    title: "Nueva Temporada de Cultivo",
    description: "Registra una nueva temporada para empezar a rastrear rendimiento, uso de agua y cosecha.",
    cropType: "Tipo de Cultivo",
    selectCrop: "Seleccionar cultivo",
    variety: "Variedad (opcional)",
    varietyPlaceholder: "Ej., Arbequina, Tempranillo...",
    plantingDate: "Fecha de Siembra",
    expectedHarvest: "Cosecha Esperada (opcional)",
    selectDate: "Seleccionar fecha",
    notes: "Notas (opcional)",
    notesPlaceholder: "Observaciones sobre la siembra, condiciones del suelo, etc.",
    cancel: "Cancelar",
    create: "Crear Temporada",
    creating: "Creando..."
  },
  cropSeasonManager: {
    activeSeason: "Temporada Activa",
    manageCycle: "Gestiona tu ciclo de cultivo actual",
    newSeason: "Nueva Temporada",
    crop: "Cultivo",
    plantingDate: "Fecha de Siembra",
    expectedHarvest: "Cosecha Esperada",
    notSet: "Sin establecer",
    status: "Estado",
    irrigations: "Riegos",
    waterUsed: "Agua Usada",
    rainfallAccum: "Lluvia Acum.",
    recordHarvest: "Registrar Cosecha",
    cancel: "Cancelar",
    noActiveSeason: "No hay temporada activa. Inicia una nueva para empezar a rastrear tu cultivo.",
    startNewSeason: "Iniciar Nueva Temporada",
    history: "Historial",
    comparison: "Comparación",
    previousSeasons: "Temporadas Anteriores",
    historicalForParcel: "Temporadas históricas de esta parcela",
    period: "Período",
    yield: "Rendimiento",
    totalWater: "Agua Total",
    efficiency: "Eficiencia",
    quality: "Calidad",
    notRecorded: "No registrado",
    noPreviousSeasons: "Sin temporadas anteriores registradas",
    overdueBy: "Vencida hace {{days}} días",
    today: "¡Hoy!",
    daysRemaining: "{{days}} días restantes",
    statusActive: "Activa",
    statusHarvested: "Cosechada",
    statusCancelled: "Cancelada",
    statusPlanning: "Planificación"
  },
  supportTicketsPage: {
    title: "Tickets de Soporte",
    subtitle: "Soporte técnico con tiempo de respuesta de 48 horas",
    newTicket: "Nuevo Ticket",
    cancel: "Cancelar",
    createTicket: "Crear Ticket de Soporte",
    teamResponds: "Nuestro equipo responderá en 48 horas",
    category: "Categoría",
    priority: "Prioridad",
    subject: "Asunto",
    subjectPlaceholder: "Descripción breve del problema",
    description: "Descripción",
    descriptionPlaceholder: "Descripción detallada de tu problema o solicitud",
    submit: "Enviar Ticket",
    creating: "Creando...",
    fillAll: "Por favor completa todos los campos requeridos",
    ticketCreated: "Ticket Creado",
    willRespond: "Nuestro equipo responderá en 48 horas",
    noTicketsYet: "Aún no tienes tickets de soporte. Crea uno si necesitas ayuda.",
    responseFrom: "Respuesta del Equipo de Soporte:",
    resolved: "Resuelto",
    statusOpen: "Abierto",
    statusInProgress: "En Progreso",
    statusResolved: "Resuelto",
    catTechnical: "Problema Técnico",
    catBilling: "Facturación",
    catFeature: "Solicitud de Función",
    catData: "Calidad de Datos",
    catAccount: "Cuenta",
    prioLow: "Baja",
    prioMedium: "Media",
    prioHigh: "Alta",
    prioUrgent: "Urgente",
    linkManual: "Manual de Usuario",
    linkManualDesc: "Guía completa de la plataforma",
    linkLearning: "Centro de Aprendizaje — Próximamente",
    linkLearningDesc: "Tutoriales y quizzes estarán disponibles en una actualización futura",
    linkDataSources: "Fuentes de Datos",
    linkDataSourcesDesc: "De dónde provienen nuestros datos",
    linkEmail: "Contactar por email"
  },
  groundTruthPage: {
    title: "Validación de Terreno",
    subtitle: "Compara datos de teledetección satelital con mediciones de campo in-situ para validación científica",
    academicBadge: "🎓 Herramienta Académica",
    tabComparison: "Satélite vs Terreno",
    tabObservations: "Observaciones de Campo",
    tabMetrics: "Métricas de Validación",
    config: "Configuración del Análisis",
    configDesc: "Selecciona parcela y rango de fechas para la validación",
    parcel: "Parcela",
    selectParcel: "Seleccionar parcela",
    startDate: "Fecha de Inicio",
    endDate: "Fecha de Fin",
    comparisonType: "Tipo de Comparación",
    allParameters: "Todos los Parámetros",
    ndviOnly: "Solo NDVI",
    soilMoistureOnly: "Solo Humedad del Suelo",
    runAnalysis: "Ejecutar Análisis de Validación",
    analyzing: "Analizando...",
    selectParcelError: "Por favor selecciona una parcela",
    analysisComplete: "Análisis Completo",
    comparedPoints: "Comparados {{n}} puntos de datos",
    satelliteRecords: "Registros Satelitales",
    groundTruthRecords: "Mediciones de Campo",
    validComparisons: "Comparaciones Válidas",
    dataQuality: "Calidad de Datos",
    ndviStats: "Estadísticas de Validación NDVI",
    exportData: "Exportar Datos",
    rSquared: "Correlación R²",
    rmse: "RMSE",
    avgDiff: "Diferencia Media",
    sampleSize: "Tamaño Muestral",
    methodology: "📚 Notas de Metodología",
    method1: "• Análisis de correlación con coeficiente R² de Pearson",
    method2: "• Coincidencia temporal: ventana de ±3 días entre mediciones satelitales y de campo",
    method3: "• RMSE (Error Cuadrático Medio) calculado para evaluación de precisión",
    method4: "• Umbrales de calidad: Excelente (R²>0.8), Buena (0.6-0.8), Aceptable (0.4-0.6), Pobre (<0.4)",
    exportComplete: "Exportación Completa",
    exportSuccess: "Datos en formato académico exportados con éxito"
  },
  cropSeasonsPage: {
    activeSeason: "Temporada Activa",
    manageCycle: "Gestiona tu ciclo de cultivo actual",
    newSeason: "Nueva Temporada",
    startNewSeason: "Iniciar Nueva Temporada",
    noActive: "No hay temporada activa. Inicia una nueva temporada para comenzar el seguimiento de tu cultivo.",
    crop: "Cultivo",
    plantingDate: "Fecha de Siembra",
    expectedHarvest: "Cosecha Esperada",
    notSet: "No definida",
    status: "Estado",
    overdueBy: "Atrasado por {{n}} días",
    today: "¡Hoy!",
    daysRemaining: "{{n}} días restantes",
    irrigations: "Riegos",
    waterUsed: "Agua Usada",
    rainfallAccum: "Lluvia Acum.",
    recordHarvest: "Registrar Cosecha",
    cancel: "Cancelar",
    statusActive: "Activa",
    statusHarvested: "Cosechada",
    statusCancelled: "Cancelada",
    statusPlanning: "Planificación",
    history: "Historial",
    comparison: "Comparación",
    previousSeasons: "Temporadas Anteriores",
    historicalDesc: "Temporadas históricas de esta parcela",
    period: "Periodo",
    yieldLabel: "Rendimiento",
    totalWater: "Agua Total",
    efficiency: "Eficiencia",
    quality: "Calidad",
    notRecorded: "No registrado",
    noPrevious: "Sin temporadas anteriores registradas"
  },
  riskAnalysisMlPage: {
    title: "Análisis de Riesgo ML",
    aiPowered: "Con IA",
    subtitle: "Predicción inteligente con caché y datos históricos reales",
    aiCardTitle: "Análisis de Riesgo con IA",
    aiCardSubtitle: "Análisis inteligente con caché de 7 días + límite de 10 predicciones/día",
    active: "Activo",
    cache7days: "Caché: 7 días",
    limit10: "Límite: 10 predicciones/día",
    selectTitle: "Seleccionar Parcela o Ubicación",
    selectDesc: "Selecciona una parcela existente o introduce manualmente la provincia y el cultivo",
    parcel: "Parcela",
    selectParcelPlaceholder: "Seleccionar parcela...",
    manualEntry: "📝 Entrada manual",
    province: "Provincia *",
    selectProvince: "Seleccionar provincia...",
    crop: "Cultivo *",
    selectCrop: "Seleccionar cultivo...",
    condition: "Condición",
    rainfed: "Secano",
    irrigated: "Regadío",
    analyze: "Analizar Riesgo",
    analyzing: "Analizando...",
    aiPredictionTitle: "Predicción con IA",
    aiPredictionDesc: "El modelo envía datos históricos agregados a la IA junto con contexto de etapa fenológica, riesgos estacionales y estadísticas de rendimiento. La caché de 7 días reduce los costes de IA en un 90%.",
    badgeRealData: "100% Datos Reales",
    badgeGenAI: "IA Generativa",
    badge7Cache: "Caché 7 Días",
    badgePdf: "Exportar PDF"
  },
  fieldNotebookPage: {
    backToDashboard: "Volver al Panel",
    parcelNotProvided: "ID de parcela no proporcionado",
    parcelNotFound: "Parcela no encontrada",
    failedToLoad: "Error al cargar parcela"
  },
  fieldNotebook: {
    title: "Cuadernos de Campo",
    subtitle: "Registros digitales de actividades agrícolas para todas tus parcelas",
    subtitleTrack: "Rastrea y valida actividades agrícolas en todas tus parcelas",
    noParcelsFound: "Sin Parcelas Encontradas",
    noParcelsDesc: "Necesitas añadir parcelas antes de empezar a registrar actividades de campo.",
    addFirstParcel: "Añadir Tu Primera Parcela",
    loading: "Cargando cuadernos de campo...",
    activities: "Actividades",
    validated: "Validadas",
    lastActivity: "Última Actividad",
    noActivitiesYet: "Sin actividades registradas aún",
    openNotebook: "Abrir Cuaderno de Campo",
    irrigation: "Riego",
    fertilization: "Fertilización",
    pestControl: "Control de Plagas",
    harvest: "Cosecha",
    pruning: "Poda",
    planting: "Siembra",
    weeding: "Deshierbe",
    other: "Otro"
  },
  pkPage: {
    title: "Optimizador de Fertilizantes P&K",
    subtitle: "Optimiza la aplicación de fósforo y potasio basándote en zonas NDVI y análisis de suelo",
    ndviBasedZones: "Zonas basadas en NDVI",
    ndviZonesDesc: "Aplicación a tasa variable basada en el vigor del cultivo",
    scientificRatios: "Ratios Científicos",
    scientificRatiosDesc: "Fórmulas validadas por UC Davis, FAO e IPNI",
    costSavings: "Ahorro de Costes",
    costSavingsDesc: "Reduce el desperdicio de fertilizantes en un 10-25%",
    selectParcel: "Seleccionar Parcela",
    selectParcelDesc: "Elige la parcela para la que quieres optimizar la fertilización",
    noParcelsFound: "No se encontraron parcelas. Añade una parcela primero para usar el Optimizador P&K."
  },
  pestPage: {
    title: "Gestión de plagas y enfermedades",
    subtitle: "Monitoriza la salud del cultivo, señales de riesgo y observaciones de campo para revisión agronómica.",
    noParcelsFound: "No Se Encontraron Parcelas",
    noParcelsDesc: "Añade una parcela primero para monitorear plagas y enfermedades",
    ruleBasedBadge: "Basado en reglas",
    weatherBasedBadge: "Basado en clima",
    satelliteObservedBadge: "Observado por satélite",
    dataLimitedBadge: "Datos limitados",
    betaBadge: "Beta",
    scoutingAvailableBadge: "Scouting disponible",
    noScoutingBadge: "Sin datos de scouting",
    disclaimerRuleBased: "Los modelos de riesgo sanitario se basan actualmente en reglas y deben validarse con scouting de campo antes de cualquier decisión de intervención.",
    relatedModulesHint: "Módulos independientes — complementarios a las vistas contextuales anteriores.",
    openIrrigationReports: "Abrir Informes de riego",
    openHarvestEstimator: "Abrir Estimador de valor de cosecha",
    flow: {
      tabSummary: "Resumen",
      tabEvidence: "Evidencia",
      tabZones: "Zonas de riesgo",
      tabAction: "Plan de acción",
      stepSummary: "Estado de riesgo",
      stepEvidence: "Evidencia",
      stepZones: "Zonas",
      stepAction: "Acción",
      subtitleSummary: "Vista resumida del riesgo actual de plagas y enfermedades, confianza y siguiente acción para esta parcela.",
      subtitleEvidence: "Señales utilizadas, datos faltantes y confianza detrás de la evaluación de riesgo actual. Esta vista explica la evidencia detrás de la evaluación. No sugiere intervenciones por sí sola.",
      subtitleZones: "Dónde aparecen señales de riesgo o zonas de bajo vigor dentro de la parcela.",
      subtitleAction: "Siguiente paso sugerido y superficie prioritaria para revisión. Solo apoyo a la revisión — no es una prescripción de productos.",
      noPriorityZonesEmpty: "No se detectan zonas prioritarias con las señales actuales.",
      ctaEvidence: "Ver evidencia",
      ctaZones: "Ver zonas de riesgo",
      ctaAction: "Ir al plan de acción"
    },
    tabHealth: "Salud del cultivo",
    tabRiskMap: "Mapa de riesgo",
    tabDiseaseModels: "Modelos de riesgo sanitario",
    tabOverview: "Resumen",
    tabImageDiagnosis: "Diagnóstico por imagen",
    tabScouting: "Registros de scouting",
    aiAssistedBetaBadge: "Asistido por IA · Beta",
    relatedModules: "Módulos relacionados",
    viewIrrigation: "Ver estado de riego",
    viewHarvest: "Ver previsión de cosecha",
    scoutingTitle: "Registros de scouting",
    scoutingComingSoon: "Próximamente: registro de scouting de campo. Usa el Cuaderno de Campo para anotar observaciones mientras tanto.",
    openFieldNotebook: "Abrir Cuaderno de Campo",
    tabRiskIntelligence: "Inteligencia de riesgo",
    riskIntel: {
      heading: "Inteligencia de riesgo",
      subheading: "¿Puedo confiar en este resultado de riesgo y qué datos faltan?",
      modelStatusTitle: "Estado del modelo",
      modelStatusBody: "Las señales actuales de riesgo se basan en reglas y clima.",
      signalsUsedTitle: "Señales utilizadas",
      signalCrop: "Tipo de cultivo",
      signalWeather: "Condiciones meteorológicas",
      signalDb: "Base de datos de plagas/enfermedades",
      signalSatellite: "Contexto satelital de vegetación",
      signalGdd: "GDD (grados-día acumulados)",
      signalScouting: "Scouting de campo",
      ifAvailable: "si está disponible",
      available: "Disponible",
      missing: "No disponible",
      missingSignalsTitle: "Señales que faltan",
      missingNoGdd: "Sin GDD disponible",
      missingNoScouting: "Sin registros de scouting",
      missingNoDiagnosis: "Sin diagnóstico de campo confirmado",
      missingNoPhenology: "Sin señal de fenología / estado del cultivo",
      noneMissing: "Todas las señales principales disponibles",
      confidenceTitle: "Confianza",
      confHigh: "Alta",
      confMedium: "Media",
      confLow: "Baja",
      confDataLimited: "Datos limitados",
      confidenceHint: "Calculada a partir de las señales disponibles — no inventada.",
      validationWarning: "Usa esto como apoyo a la revisión. Valida con scouting de campo antes de cualquier decisión de intervención.",
      ctaViewMap: "Ver mapa de riesgo actual",
      gddAvailable: "Disponible",
      gddMissing: "Faltante",
      gddCurrentLabel: "GDD actual",
      gddWeatherDerivedBadge: "Derivado del clima",
      gddEnableHint: "Ejecuta o activa el cálculo GDD para esta parcela para mejorar la confianza del riesgo sanitario."
    },
    tabTreatmentSupport: "Apoyo a la revisión fitosanitaria",
    treatmentSupport: {
      heading: "Apoyo a la revisión fitosanitaria",
      subheading: "¿Qué debo hacer ahora: monitorear, hacer scouting o solicitar revisión agronómica?",
      disclaimer: "Esta es una vista de apoyo a la revisión. Valida con scouting de campo y criterio agronómico antes de cualquier decisión de intervención.",
      card1Title: "Estado actual del riesgo",
      noRiskSignal: "No se detecta riesgo alto de plagas o enfermedades",
      mainRiskLevel: "Nivel de riesgo principal",
      mainSignal: "Señal principal",
      confidence: "Confianza",
      gddStatus: "GDD",
      scoutingStatus: "Scouting",
      scoutingConfirms: "Incidencia reportada en campo",
      scoutingNoIssue: "Sin incidencias reportadas",
      scoutingMissing: "Sin registros de scouting",
      scoutingMissingHint: "Crea un registro de scouting para aumentar la confianza antes de cualquier decisión de intervención.",
      risk_high: "Alto",
      risk_medium: "Medio",
      risk_low: "Bajo",
      risk_none: "Sin datos",
      card2Title: "Siguiente acción sugerida",
      decisionSupportNote: "Solo apoyo a la revisión — no es un diagnóstico fitosanitario ni una prescripción de productos.",
      actionConsiderTitle: "Solicitar revisión agronómica de las zonas afectadas.",
      actionConsiderBody: "Se detecta riesgo alto y el scouting reporta una incidencia. Considera una intervención dirigida en las zonas prioritarias, validada por un agrónomo.",
      actionConsiderLabel: "Solicitar revisión agronómica",
      actionScoutTitle: "Realizar scouting en zonas prioritarias antes de cualquier decisión de intervención.",
      actionScoutBody: "Se detecta riesgo alto pero sin confirmación de campo. Inspecciona las zonas prioritarias antes de cualquier decisión.",
      actionScoutLabel: "Scouting",
      actionMonitorScoutTitle: "Monitorear y programar scouting.",
      actionMonitorScoutBody: "Riesgo medio detectado. Continúa el monitoreo y planifica una visita de scouting.",
      actionMonitorScoutLabel: "Monitorear / Scouting",
      actionMonitorTitle: "No se requiere intervención inmediata según la evidencia disponible. Continuar monitoreo.",
      actionMonitorBody: "Las señales de riesgo son bajas. Mantén el monitoreo rutinario.",
      actionMonitorLabel: "Continuar monitoreo",
      card3Title: "Priorización por zonas",
      noZones: "Aún no hay apoyo por zonas disponible. Genera primero zonas NDVI/de vegetación desde Satellite Intelligence o Nitrogen Optimizer.",
      noPriorityZones: "No se detectan zonas de bajo vigor o anómalas en el último análisis.",
      reasonLowVigor: "bajo vigor",
      card4Title: "Superficie prioritaria para revisión",
      noReductionEstimate: "Esta estimación estará disponible cuando existan zonas de vegetación y área de parcela.",
      totalArea: "Superficie total",
      priorityArea: "Superficie prioritaria",
      avoidedArea: "Superficie evitada",
      avoidedPercent: "Reducción",
      reductionNote: "Estimación de la superficie prioritaria para revisión, no de una reducción confirmada de productos.",
      ctaOpenRiskMap: "Abrir mapa de riesgo",
      ctaOpenNotebook: "Abrir cuaderno de campo / Añadir scouting",
      dataDependentBadge: "Depende de datos",
      fieldValidationBadge: "Requiere validación de campo",
      noPrescriptionBadge: "Sin prescripción de pesticidas",
      mandatoryDisclaimer: "Solo apoyo a la revisión. Sentinel Crop no prescribe pesticidas, productos ni dosis. Las decisiones finales de intervención deben ser validadas por un técnico cualificado y por la etiqueta del producto.",
      priorityScoreTitle: "Prioridad de revisión",
      priorityScoreSuffix: "/100",
      waterStressCheckTitle: "Comprobación de estrés hídrico",
      waterStressStrong: "Señal fuerte de estrés hídrico detectada. Prioridad reducida — revisar el riego antes de cualquier decisión de intervención.",
      waterStressPartial: "Señal parcial de estrés hídrico detectada. Prioridad ligeramente ajustada; se requiere scouting de campo.",
      waterStressNone: "No se detecta una señal significativa de estrés hídrico en los indicadores disponibles.",
      waterStressUnknown: "No hay indicadores de estrés hídrico disponibles para esta parcela.",
      waterStressSignalsTitle: "Señales consideradas",
      waterStressSignalNdwi: "NDWI",
      waterStressSignalNdmi: "NDMI",
      waterStressSignalBalance: "Balance hídrico FAO-56",
      waterStressSignalRain: "Déficit de lluvia",
      waterStressSignalAlert: "Alerta de estrés hídrico",
      waterStressNotAvailable: "No disponible",
      scoutingRequiredTitle: "Se requiere scouting",
      scoutingRequiredBody: "Sin un reporte de scouting reciente o evidencia de campo, el sistema no puede sugerir ninguna intervención como acción directa. La sugerencia máxima permitida es: \"Solicitar revisión agronómica tras validación de campo\".",
      whyTitle: "¿Por qué esta recomendación?",
      driverLocalNdvi: "caída localizada de NDVI",
      driverRapidDecline: "caída rápida de NDVI",
      driverDiseaseWeather: "clima favorable a enfermedad",
      driverPestWindow: "ventana activa de riesgo de plaga/enfermedad",
      driverPhenology: "estadio fenológico sensible",
      noDriversDetected: "No se detectan drivers fuertes en las señales disponibles.",
      actionReviewIrrigationLabel: "Revisar riego primero",
      actionReviewIrrigationTitle: "Revisar estado de riego y hacer scouting antes de cualquier decisión de intervención.",
      actionReviewIrrigationBody: "Los indicadores de estrés hídrico dominan la anomalía actual. Verifica el estado de riego y realiza una visita de scouting antes de cualquier decisión de intervención.",
      actionConsiderAfterValidationLabel: "Solicitar revisión agronómica tras validación de campo",
      actionConsiderAfterValidationTitle: "Solicitar revisión agronómica tras validación de campo.",
      actionConsiderAfterValidationBody: "Las señales de riesgo y el scouting de campo coinciden. Puede considerarse una intervención dirigida en las zonas prioritarias tras validación agronómica. Sentinel Crop no prescribe productos ni dosis.",
      reportReadyTitle: "Explicación lista para informe",
      reportReadyCopy: "Copiar",
      reportReadyCopied: "Copiado",
      reportReadyNotAutoAdded: "Este es un resumen listo para informe que puedes copiar en el Cuaderno de Campo, notas del asesor o un informe externo. Todavía no se añade automáticamente al Centro de Informes.",
      expLead: "Sentinel Crop identificó {{zones}} zona(s) prioritaria(s) que representan {{priorityHa}} ha de una parcela de {{totalHa}} ha.",
      expDrivenBy: "La señal está impulsada por",
      expWaterStrong: "Los indicadores de estrés hídrico explican en gran medida la anomalía, por lo que se requiere revisar el riego y hacer scouting antes de cualquier decisión de intervención.",
      expWaterPartial: "Los indicadores de estrés hídrico explican parte de la anomalía, por lo que se requiere scouting antes de cualquier decisión de intervención.",
      expWaterNone: "Los indicadores de estrés hídrico no explican la anomalía.",
      expWaterUnknown: "No hay indicadores de estrés hídrico disponibles para esta parcela; interpreta la conclusión con cautela.",
      expScoutingRequired: "Se requiere scouting de campo antes de cualquier decisión de intervención.",
      expScoutingPresent: "El scouting de campo confirma una incidencia en la parcela.",
      expReduction: "Reducción estimada de la superficie a revisar frente a revisar toda la parcela: {{pct}}%.",
      expReductionUnavailable: "La reducción de la superficie a revisar no puede estimarse con los datos actuales.",
      expLimitations: "Limitaciones de datos: {{items}}.",
      expNoPriority: "No se detectan zonas prioritarias con las señales actuales. Continúa el monitoreo rutinario.",
      limNoNdviHistory: "sin historial NDVI",
      limNoWaterIndices: "sin NDWI/NDMI",
      limNoWaterBalance: "sin balance FAO-56",
      limNoScouting: "sin registro de scouting",
      limNoZoneArea: "área por zona aproximada",
      limNoParcelArea: "sin área de parcela",
      limNoGdd: "sin GDD"
    }
  },
  cropResourcesPage: {
    title: "Base de Conocimiento de Cultivos",
    subtitle: "Guía de referencia agrícola completa para planificación y gestión de cultivos",
    comparativeTable: "Tabla Comparativa",
    cropVarieties: "Variedades de Cultivo",
    plantingSeasons: "Temporadas de Siembra",
    growthStages: "Etapas de Crecimiento",
    cropComparison: "📊 Resumen Comparativo de Cultivos",
    cropComparisonDesc: "Parámetros agronómicos clave para los principales cultivos",
    crop: "Cultivo",
    totalCycle: "Ciclo Total",
    phases: "Fases",
    baseTemp: "Temp. Base",
    kcMax: "Kc Máx",
    gddTotal: "GDD Total",
    type: "Tipo",
    perennial: "Perenne",
    annual: "Anual",
    varieties: "variedades",
    varietiesDesc: "Variedades comerciales comunes con características y adaptación regional",
    typicalYield: "Rendimiento Típico:",
    mainRegions: "Regiones Principales:",
    europePlanting: "Europa - Siembra y Cosecha",
    latamPlanting: "Latinoamérica - Siembra y Cosecha",
    planting: "Siembra",
    harvest: "Cosecha",
    daysCycle: "días de ciclo",
    days: "días"
  },
  fertilizationPage: {
    title: "Gestión de Fertilización",
    nutrientWizard: "Asistente de Balance Nutricional",
    selectParcel: "Seleccionar Parcela",
    selectParcelPlaceholder: "Seleccionar una parcela",
    noCrop: "Sin cultivo",
    nutrientBalanceCalculated: "Balance Nutricional Calculado",
    nutrientBalanceApplied: "Balance Nutricional Aplicado",
    targetYield: "objetivo",
    nitrogenVRA: "Nitrógeno (N) VRA",
    pkOptimizer: "Optimizador P&K"
  },
  traceabilityPage: {
    title: "Trazabilidad Blockchain",
    subtitle: "Crea y gestiona lotes de productos con seguimiento blockchain y transparencia total de la cadena de suministro",
    productBatches: "Lotes de Productos",
    qrCodes: "Códigos QR",
    qrComingSoon: "Gestión de códigos QR próximamente..."
  },
  paymentCancelled: {
    title: "Pago Cancelado",
    subtitle: "Tu compra de póliza de seguro no se completó",
    whatHappened: "¿Qué ocurrió?",
    cancelledExplanation: "El proceso de pago fue cancelado. Esto puede ocurrir por varias razones:",
    reason1: "Cancelaste el pago en la página de Stripe",
    reason2: "Hubo un problema con tu método de pago",
    reason3: "La sesión de pago expiró por inactividad",
    protectionAwaits: "Tu Protección Agrícola Te Espera",
    tryAgainMessage: "No te preocupes, puedes intentarlo de nuevo cuando estés listo. Tu configuración de póliza se guardará.",
    benefitsTitle: "Beneficios de proteger tus cultivos:",
    benefit1: "Protección contra sequías y eventos climáticos extremos",
    benefit2: "Pagos automáticos basados en datos satelitales",
    benefit3: "Monitoreo 24/7 de tus parcelas",
    benefit4: "Sin inspecciones manuales ni papeleo",
    backToDashboard: "Volver al Panel",
    tryAgain: "Intentar de Nuevo"
  },
  paymentSuccess: {
    title: "¡Póliza Activada!",
    subtitle: "Tu póliza de seguro agrícola está ahora activa",
    policyNumber: "Número de Póliza",
    startDate: "Fecha de Inicio",
    coverageType: "Tipo de Cobertura",
    status: "Estado",
    nextSteps: "Próximos Pasos",
    step1: "Revisa tu email para la confirmación",
    step2: "Configura alertas para tus parcelas cubiertas",
    step3: "Consulta tu póliza en el panel de Seguros",
    goToDashboard: "Ir al Panel",
    viewInsurance: "Ver Seguros"
  },
  missionControl: {
    title: "Centro de Control",
    subtitle: "Tus tareas diarias y alertas críticas de un vistazo",
    pendingTasks: "Tareas Pendientes",
    activeAlerts: "Alertas Activas",
    completedToday: "Completadas Hoy",
    overdueTasks: "Tareas Vencidas",
    todaysTasks: "Tareas de Hoy",
    noTasksToday: "No hay tareas programadas para hoy",
    criticalAlerts: "Alertas Críticas",
    noActiveAlerts: "Sin alertas activas — todas las parcelas se ven saludables",
    markComplete: "Marcar Completada",
    viewParcel: "Ver Parcela",
    dismiss: "Descartar"
  },
  phenologyIntel: {
    title: "Inteligencia fenológica",
    subtitle: "Inteligencia de etapa del cultivo para decisiones de riego, riesgo sanitario, fertilización y cosecha.",
    selectParcel: "Seleccionar parcela",
    selectParcelPlaceholder: "Elige una parcela",
    loading: "Cargando parcelas...",
    noParcels: "No se encontraron parcelas.",
    currentStage: "Etapa actual",
    cumulativeGdd: "GDD acumulados",
    lastObservation: "Última observación",
    daysAheadBehind: "Días adelantado/atrasado",
    notAvailable: "No disponible",
    noStage: "Aún no hay etapa fenológica disponible para esta parcela. Añade una observación de campo o ejecuta el cálculo GDD si está disponible.",
    noCropConfig: "La configuración fenológica aún no está disponible para este cultivo.",
    recordObservation: "Registrar observación",
    recordObservationHint: "La etapa observada por el usuario corrige y valida la etapa usada por los motores aguas abajo.",
    selectStagePlaceholder: "Selecciona una etapa",
    notesPlaceholder: "Notas opcionales...",
    saveObservation: "Guardar observación",
    saving: "Guardando...",
    selectStageError: "Selecciona una parcela y una etapa.",
    observationSaved: "Observación guardada",
    updateFailed: "Error al actualizar",
    recommendedActions: "Acciones recomendadas",
    footer: "Las estimaciones fenológicas son señales de apoyo a la decisión. Pueden basarse en observaciones del usuario, cálculos GDD y configuración de etapas por cultivo cuando estén disponibles. Valida con observaciones de campo antes de tomar decisiones operativas.",
    badges: {
      decisionSupport: "Apoyo a la decisión",
      dataDependent: "Depende de datos",
    },
    source: {
      user_observed: "Observada por usuario",
      gdd_estimated: "Estimada por GDD",
      none: "No disponible",
    },
    confidence: {
      high: "Confianza alta",
      medium: "Confianza media",
      low: "Confianza baja",
      data_limited: "Datos limitados",
    },
    impacts: {
      irrigation: {
        title: "Sensibilidad al riego",
        body: "La etapa actual afecta el Kc y la sensibilidad al riego.",
        latest: "Última recomendación FAO-56: {{date}}.",
        noResult: "No hay resultado FAO-56/Kc reciente disponible.",
      },
      pest: {
        title: "Ventana de plagas y enfermedades",
        body: "La etapa influye en la ventana de riesgo sanitario. Contrasta con el Mapa de riesgo y scouting de campo.",
        noConfig: "La ventana específica de riesgo sanitario por etapa no está configurada para este cultivo. Usa el Mapa de riesgo y scouting de campo.",
      },
      fertilization: {
        title: "Momento de fertilización",
        body: "La fenología ayuda a contextualizar el momento de nitrógeno y fertilización.",
      },
      harvest: {
        title: "Pronóstico de cosecha",
        body: "La fenología se usa para contextualizar la madurez de cosecha y la confianza del pronóstico.",
      },
    },
    actions: {
      addObservation: "Añade una observación fenológica para mejorar las recomendaciones posteriores.",
      runGdd: "Ejecuta o actualiza el cálculo GDD para esta parcela.",
      scheduleScouting: "Programa scouting de campo para validar riesgos sensibles a la etapa.",
    },
    ctas: {
      openIrrigation: "Abrir Riego",
      openPestDiseases: "Abrir Plagas y Enfermedades",
      openNitrogen: "Abrir Optimizador de Nitrógeno",
      openHarvest: "Abrir Pronóstico de Cosecha",
      fieldNotebook: "Abrir Cuaderno de campo",
    },
  }
};
